// extracted by mini-css-extract-plugin
module.exports = {"container":"SignInButton_container__1PBpH","iconContainer":"SignInButton_iconContainer__lV0v1","icon":"SignInButton_icon__3lc83","label":"SignInButton_label__1QWw2"};